module.exports = {"ANALYZED":"Analyzed","CONDUCTED":"Conducted","ENROLLMENT":"Enrollment","RECRUITMENT":"Recruitment"}